import styled from 'styled-components';
import BaseMapMarkerIcon from '#/shared/components/GeneratedIcons/trimet/MapMarkerSolid';
import BaseArrowLeftIcon from '#/shared/components/GeneratedIcons/generic/ArrowLeft';
import { ClearButton } from '#/shared/components/Styled';

// TODO: Fix so the the TripSummaryInner is responsive and hovers work

export const TripSummarySection = styled.div`
  display: flex;
  background-color: ${props => props.theme.activeColor};
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  padding: 1em 1em 0.125em;
`;

export const SummaryButton = styled(ClearButton)`
  border-radius: ${props => props.theme.buttonRadius};
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.45);
  color: ${props => props.theme.mainColor};
  background-color: ${props => props.theme.secondaryBackgroundColor};
  display: flex;
  align-items: center;
  flex-flow: row;
  width: 100%;
  max-width: 500px;
  font-size: 0.8em;
  padding: 4px 0;
`;

export const AddressColumn = styled.div`
  display: flex;
  color: ${props => props.theme.mainColor};
  flex: 1 0 auto;
  width: 1px;
  min-width: 1px;
`;

export const AddressText = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IconColumn = styled.div`
  flex: 0;
  margin: 4px;
  display: flex;
`;

export const ChevronIcon = styled(BaseArrowLeftIcon).attrs(props => ({
  width: 15,
  height: 15,
  fill: props.theme.secondaryFontColor,
}))`
  transform: rotate(0.5turn);
`;

export const OriginIcon = styled(BaseMapMarkerIcon).attrs(props => ({
  height: 20,
  width: 20,
  fill: props.theme.originColor,
}))``;

export const DestinationIcon = styled(BaseMapMarkerIcon).attrs(props => ({
  height: 20,
  width: 20,
  fill: props.theme.destinationColor,
}))``;
